'use strict';

angular.module('cvsApp').controller('loaderCtrl', ['$scope', 'networkRequestFactory','$location','configservice','PageValues','redirectService', 'loggerService', 'loggerServiceHelper','validateDeepLinkService',
	function ($scope,networkRequest,location,config,PageValues,redirectService, loggerService, loggerServiceHelper,VDLS) {
	var log = loggerService(loggerServiceHelper.setCategory('redirector'));

	var getFastProxyUrl = function (url) {
		return url.replace('wps/', 'FASTPROXY/');
	}

	if (log && log.info) {
		log.info(loggerServiceHelper.setFlow('redirector') + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setDescription("redirector page load"));
	}

	if(window.location.pathname && window.location.pathname.contains('app')){
		PageValues.routeParam="app";
	}else if(window.location.pathname && window.location.pathname.contains('web')){
		PageValues.routeParam="web";
	}

	if(!cvsUtility.queryMap.xid && window.location.hash) {
		var xidValue=window.location.hash;
		xidValue=decodeURIComponent(xidValue);
		xidValue=xidValue.replace("#!/#/","");
			console.log("HASH Value= ",xidValue);
		PageValues.xid=xidValue;
	}
	/*//success callback to get WCM Call
	var successRetrieveWCMCallback=function(data){
		console.log("In successRetrieveWCMCallback");
		//PageValues.wcm.securechat=data;
		redirectTo("WCM SUCCESS");
	};
	
	//error callback to get WCM Call
	var errorRetrieveWCMCallback=function(data){
		console.log("In errorRetrieveWCMCallbackCallback");
		redirectTo("WCM FAILURE");
	};*/

	//success callback function
	var successCampaignCallback=function(data) {
		if(data && data.hasOwnProperty('validateLinkResponse') && data.validateLinkResponse.header
			&& data.validateLinkResponse.header.statusCode && data.validateLinkResponse.header.statusCode=="DBPL0000"){
			if(data.validateLinkResponse.details && data.validateLinkResponse.details ){
				PageValues.appConfig.validateResponse={
					"partialToken":data.validateLinkResponse.header.tokenID,
					"memberOnlineStatus":data.validateLinkResponse.details.specialtyPatientMessage.memberInfoEnc.memberStatus,
					"contextInformation":data.validateLinkResponse.details.contextInformation,
					"secureData":data.validateLinkResponse.details.xidInfo,
					"trackingInformation":data.validateLinkResponse.details.trackingInformation,
					"memberInfoEnc":data.validateLinkResponse.details.specialtyPatientMessage.memberInfoEnc,
					"redirect_url":data.validateLinkResponse.details.xidInfo.redirect_url
				};
				if (log && log.exit) {
					log.exit(loggerServiceHelper.setFlow("redirector") + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.NAVIGATION) + "campaign=" + cvsUtility.queryMap.cmp + ", " + "xID=" + (cvsUtility.queryMap.xid || PageValues.xid) + ", "+
					  loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("validateDeepLink") + loggerServiceHelper.setDescription("validateDeepLink service success"));
				  }
				//networkRequest.wcmConfigDetails.retrieveData('','',successRetrieveWCMCallback,errorRetrieveWCMCallback);
				redirectTo();
			}else{
				if (log && log.error) {
					log.error(loggerServiceHelper.setFlow('redirector') + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + "campaign=" + cvsUtility.queryMap.cmp + ", " + "xID=" + (cvsUtility.queryMap.xid || PageValues.xid) + ", " +
					loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("validateDeepLink") +
					loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription("response  " + JSON.stringify(data)));
				}
				location.path("/error");
			}
		}
		else if(data && data.hasOwnProperty('validateLinkResponse') && data.validateLinkResponse.header
			&& data.validateLinkResponse.header.statusCode && data.validateLinkResponse.header.statusCode=="DBPL6029"){
			if (log && log.exit) {
				log.exit(loggerServiceHelper.setFlow('redirector') + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + "campaign=" + cvsUtility.queryMap.cmp + ", " + "xID=" + (cvsUtility.queryMap.xid || PageValues.xid) + ", " +
				loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("validateDeepLink") +
				loggerServiceHelper.setDescription("validateDeepLink service success"));
			}
			redirectTo(true);
		}
		else{
			if (log && log.error) {
				log.error(loggerServiceHelper.setFlow('redirector') + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.NAVIGATION) + "campaign=" + cvsUtility.queryMap.cmp + ", " + "xID=" + (cvsUtility.queryMap.xid || PageValues.xid) + ", " +
				loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("validateDeepLink") +
				loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription("response  " + JSON.stringify(data)));
			}
			location.path("/error");
		}
	};

	//error callback function
	var errorCampaignCallback=function(data){
		location.path("/error");
	};
	if(!cvsUtility.queryMap.accessKey && (!cvsUtility.queryMap.xid && !PageValues.xid)){
		location.path("/error");
		return;
	}

	if (log && log.debug) {
		log.debug(loggerServiceHelper.setFlow('redirector') + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + "campaign=" + cvsUtility.queryMap.cmp + ", " + "xID=" + (cvsUtility.queryMap.xid || PageValues.xid) + ", "+
		loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallStart) + loggerServiceHelper.setDescription("validate XID service called."));
	}

	var version = cvsUtility.queryMap.version && cvsUtility.queryMap.version == "new";


	if(version) {
		VDLS.validateDeepLink(function (data) { 

			if (data.SERVER_ERROR) {
				location.path("/error");
				return;
			} else if ( data.getError() === '' && data.getHeader().statusCode === '0000' ) {
				window.top.location = data.getHeader().redirectUrl;
				return;
			} else {
				window.top.location = getFastProxyUrl(PageValues.appConfig.portalUrl) + PageValues.wcm.navigationUrl.classic_login + "deepLink=expired";
			}
		});
	} else { 
		networkRequest.validateXID.retrieveData('',redirectService.validateXIDRequestBody(),successCampaignCallback,errorCampaignCallback);	
	};
	
	//Redirection function
	function redirectTo(value) {
		var url;
		if(cvsUtility.queryMap.cmp && cvsUtility.queryMap.cmp == "ccc" || cvsUtility.queryMap.cmp && cvsUtility.queryMap.cmp == "hee" ){
			redirectService.getRedirectUrl("web",value);
		} else if((cvsUtility.queryMap.route && cvsUtility.queryMap.route=="app") || (PageValues.routeParam && PageValues.routeParam=="app")){
			
			// window.top.location=redirectService.getRedirectUrl("app");
			redirectService.getRedirectUrl("app");
		}else {
			//window.top.location=redirectService.getRedirectUrl("web",value);
			redirectService.getRedirectUrl("web",value);
		}
	 }
	
}]);
